// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2bjXh","detailsBorder":"styles_detailsBorder__1gJdB"};